export default __webpack_public_path__ + "static/media/interview.8cc40644.png";